import { useQuery } from "react-query";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";
import getStructuredNoteDetails, {
  StructuredNoteDetailsResponse,
} from "../services/getStructuredNoteDetails";

function useGetStructuredNoteDetails(
  token: string,
  orgRoleId: number,
  pagination: MRT_PaginationState,
  columnFilters: MRT_ColumnFiltersState,
  sorting: MRT_SortingState,
  globalFilter: string,
  adminOrgRoleId?: number | null
) {
  return useQuery<StructuredNoteDetailsResponse>({
    queryKey: ["structured-note-details", orgRoleId, adminOrgRoleId, pagination, columnFilters, sorting, globalFilter],
    queryFn: () =>
      getStructuredNoteDetails({
        token,
        orgRoleId,
        adminOrgRoleId: adminOrgRoleId ?? undefined,
        pagination,
        columnFilters,
        sorting,
        globalFilter,
      }),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useGetStructuredNoteDetails;
